import React from "react";
import { Link } from "react-router-dom";
import { Star, MapPin, Users, Fuel, Cog, ShieldCheck, BadgeCheck, Zap, Gauge } from "lucide-react";
import { formatZAR } from "../lib/api";
import { vehiclePhoto, onPhotoError } from "../lib/photos";

export default function VehicleCard({ v }) {
  return (
    <Link
      to={`/vehicles/${v.id}`}
      className="group flex flex-col bg-white rounded-[1.25rem] overflow-hidden border border-[#E2E8F0] card-hover"
      data-testid={`vehicle-card-${v.id}`}
    >
      <div className="aspect-[4/3] w-full overflow-hidden relative bg-[#F0F2F5]">
        <img
          src={vehiclePhoto(v)}
          onError={onPhotoError(v.vehicle_type)}
          alt={v.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex gap-1.5">
          {v.instant_book && (
            <span className="inline-flex items-center gap-1 bg-white/95 backdrop-blur text-[#08153a] text-[11px] font-bold px-2.5 py-1 rounded-full shadow-sm">
              <Zap size={11} className="text-[#1d7ffd]" /> Instant book
            </span>
          )}
          {v.inspection_certified && (
            <span className="inline-flex items-center gap-1 bg-[#1d7ffd] text-white text-[11px] font-bold px-2.5 py-1 rounded-full shadow-sm">
              <BadgeCheck size={11} /> Certified
            </span>
          )}
        </div>
        {v.insurance_included && (
          <div className="absolute bottom-3 left-3">
            <span className="inline-flex items-center gap-1 bg-[#08153a]/85 text-white text-[10px] font-semibold px-2 py-0.5 rounded-md backdrop-blur">
              <ShieldCheck size={10} /> Insured
            </span>
          </div>
        )}
      </div>
      <div className="p-5 flex flex-col gap-2.5">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display text-base font-bold text-[#08153a] leading-tight line-clamp-1">
            {v.brand} {v.model}
          </h3>
          {v.rating_avg > 0 && (
            <div className="flex items-center gap-1 text-sm text-[#08153a]">
              <Star size={13} className="fill-[#08153a] text-[#08153a]" />
              <span className="font-semibold">{v.rating_avg}</span>
            </div>
          )}
        </div>
        <div className="flex items-center gap-1 text-xs text-[#64748B]">
          <MapPin size={11} /> {v.location_text}, {v.city}
        </div>
        <div className="flex items-center gap-3 text-[11px] text-[#64748B] mt-1">
          <span className="inline-flex items-center gap-1"><Cog size={11} />{v.transmission}</span>
          <span className="inline-flex items-center gap-1"><Fuel size={11} />{v.fuel_type}</span>
          <span className="inline-flex items-center gap-1"><Users size={11} />{v.seats}</span>
          <span className="inline-flex items-center gap-1" data-testid={`vehicle-card-km-${v.id}`}><Gauge size={11} />{v.km_per_day} km/day</span>
        </div>
        <div className="pt-2 border-t border-[#E2E8F0] mt-2 flex items-baseline gap-1">
          <span className="font-display text-lg font-black text-[#08153a]">{formatZAR(v.price_per_day)}</span>
          <span className="text-xs text-[#64748B]">/day</span>
        </div>
      </div>
    </Link>
  );
}
